import React from "react";
import Results from "../../../../ui/Results/Results";

export default function StudentViewResults() {
  return <Results role="Student" />;
}
